import { render } from "./StockImport.vue?vue&type=template&id=2dbc1209"
import script from "./StockImport.vue?vue&type=script&lang=js"
export * from "./StockImport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__